<template>
	<div class="post-authors">
        <avatars :users="rowData.authors" v-if="rowData.authors"></avatars>
	</div>
</template>

<script>
	export default {
		name: 'ColumnPostAuthors',
		props: {
			rowData: {
				type: Object,
				required: true
			},
			rowIndex: {
				type: Number
			}
		},
		data () {
            return {}
        },
	}
</script>
